import { PageController } from '@client/components/_core/layout/PageController';
import { History } from '@client/components/_ui/display/History';
import { createFileRoute } from '@tanstack/react-router';
import { complaintFormStore } from '../store';

export const Route = createFileRoute('/console/$orgId/compliance/complaints/details/$id/history')({
    component: ComplaintHistory,
});

function ComplaintHistory() {
    const complaint = complaintFormStore.use.formData();

    return (
        <PageController route={Route}>
            <History idValue={complaint.id} idPropertyName="complaintId" />
        </PageController>
    );
}
